import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Trash2, Check } from "lucide-react";
import { PageTitle, fmtDate } from "../../components/admin/AdminUi";
import { api, errMsg } from "../../lib/api";

export default function AdminContactInbox() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => api.adminContact().then(setRows).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const act = async (fn) => { try { await fn(); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <div data-testid="admin-contact">
      <PageTitle title="Contact inbox" desc={`${rows.filter((r) => !r.read).length} unread`} />
      <div className="space-y-3">
        {rows.length === 0 && <p className="text-sm text-slate-500">No messages yet.</p>}
        {rows.map((m) => (
          <div key={m.id} data-testid={`contact-row-${m.id}`} className={`rounded-2xl border p-5 ${m.read ? "border-slate-200/80 bg-white" : "border-emerald-200 bg-emerald-50"}`}>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              {!m.read && <span className="w-2 h-2 rounded-full bg-emerald-400" />}
              <span className="text-slate-900 font-medium">{m.name}</span>
              <span className="text-slate-500">{m.email}</span>
              <span className="px-1.5 py-0.5 rounded border border-slate-300 text-[10px] font-mono text-slate-500">{m.topic}</span>
              <span className="ml-auto text-xs text-slate-400">{fmtDate(m.created_at)}</span>
            </div>
            <p className="mt-3 text-sm text-slate-600 whitespace-pre-wrap">{m.message}</p>
            <div className="mt-4 flex gap-2">
              <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.subject || m.topic)}`} className="h-8 px-3 rounded-lg border border-slate-300 text-xs text-slate-600 hover:text-slate-900 flex items-center gap-1.5"><Mail size={12} /> Reply</a>
              {!m.read && <button onClick={() => act(() => api.adminMarkContactRead(m.id))} data-testid={`contact-read-${m.id}`} className="h-8 px-3 rounded-lg border border-slate-300 text-xs text-slate-600 hover:text-slate-900 flex items-center gap-1.5"><Check size={12} /> Mark read</button>}
              <button onClick={() => act(() => api.adminDeleteContact(m.id))} data-testid={`contact-delete-${m.id}`} className="h-8 px-3 rounded-lg border border-slate-300 text-xs text-slate-500 hover:text-rose-600 flex items-center gap-1.5"><Trash2 size={12} /> Delete</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
